import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Spinner, Modal } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { useNavigate } from "react-router-dom";
import "../styles/PresidentSecretary.css";
import axios from "axios";

const baseUrl = process.env.REACT_APP_BASEURL ;
console.log("Base URL:", baseUrl);

const PhotoAlbum = () => {
  const navigate = useNavigate();
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));
  const [albums, setAlbums] = useState([]);
  const [photos, setPhotos] = useState({});
  const [loading, setLoading] = useState(true);

  // 🔹 Modal states
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const openPhotoModal = (photo) => {
    setSelectedPhoto(photo);
    setShowModal(true);
  };

  // 🔹 Token sync
  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState) setTokenState(currentToken);
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);

  // 🔹 Fetch Albums + Photos
  useEffect(() => {
    const fetchAlbumsAndPhotos = async () => {
      try {
        const albumRes = await axios.get(`${baseUrl}/get-all-albums`);
        let albumList = albumRes.data.data || [];

        // 🔥 Sort albums by album_id DESC
        albumList = albumList.sort(
          (a, b) => Number(b.album_id) - Number(a.album_id)
        );

        // Fetch photos for each album
        const photoPromises = albumList.map((album) =>
          axios.get(`${baseUrl}/get-photos-by-album/${album._id}`)
        );

        const photoResponses = await Promise.all(photoPromises);
        const photoData = {};

        photoResponses.forEach((res, i) => {
          photoData[albumList[i]._id] = res.data.data || [];
        });

        setAlbums(albumList);
        setPhotos(photoData);
      } catch (error) {
        console.error("Error fetching albums/photos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAlbumsAndPhotos();
  }, []);

  const handleMemberLogin = () => navigate("/member-login");
  const handleEdcclogin = () => navigate("/edcc-login");

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <>
      {/* 🔷 Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">
              All India Occupational Therapists' Association
            </h1>
            {!tokenState && (
              <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate Login
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* 🔷 Scrollable Content */}
<div className="scrollable-content-home">
  <div className="content-container">
    <section className="photo-album-section">
      <Container>
        {/* Section Header with decorative line */}
        <div className="section-header-wrapper mb-5">
          <h2 className="section-main-heading">
            <span className="heading-decoration"></span>
            Photo Gallery
            <span className="heading-decoration"></span>
          </h2>
          <p className="section-subheading text-muted">Moments captured from our events and gatherings</p>
        </div>

        {albums.length === 0 ? (
          <div className="empty-state text-center py-5">
            <div className="empty-state-icon mb-3">
              <i className="bi bi-images" style={{ fontSize: '3rem', opacity: 0.5 }}></i>
            </div>
            <h5 className="text-muted">No albums available</h5>
            <p className="text-muted small">Check back later for updates</p>
          </div>
        ) : (
          <div className="albums-grid">
            {albums.map((album, index) => (
              <div key={album._id} className="album-wrapper mb-5">
                {/* Album Header with gradient accent */}
                <div className="album-header d-flex align-items-center mb-4 py-2">
                  <div className="album-icon me-3">
                    <div className="album-icon-circle">
                      <i className="bi bi-folder-fill"></i>
                    </div>
                  </div>
                  <div className="album-title-wrapper">
                    <h4 className="album-title poppins-semibold mb-1">
                      {album.album_name || album.name}
                    </h4>
                    {photos[album._id]?.length ? <span className="photo-count-badge">
                      {photos[album._id]?.length} photos
                    </span> : null}
                  </div>
                </div>

                {/* Photos Grid */}
                {photos[album._id]?.length > 0 ? (
                  <Row className="g-4">
                    {photos[album._id].map((photo, photoIndex) => (
                      <Col
                        key={photo._id}
                        xs={6}
                        md={4}
                        lg={3}
                        xl={2}
                      >
                        <div 
                          className="photo-card-wrapper"
                          style={{
                            animation: `fadeIn 0.5s ease ${photoIndex * 0.05}s both`
                          }}
                        >
                            <Card
                              className="photo-card h-100 border-0 shadow-sm custom-card"
                              style={{ padding: "0", marginBottom: "0" }}
                            >
                            <div className="photo-container position-relative">
                              <div className="photo-overlay">
                                <button 
                                  className="btn btn-light btn-sm rounded-circle view-photo-btn"
                                  onClick={() => openPhotoModal(photo)}
                                  aria-label="View photo"
                                >
                                  <i className="bi bi-zoom-in"></i>
                                </button>
                              </div>
                              <Card.Img
                                variant="top"
                                src={photo.photo_name}
                                alt={photo.photo_name}
                                className="photo-image"
                                onClick={() => openPhotoModal(photo)}
                                style={{ 
                                  cursor: "pointer",
                                  aspectRatio: '1/1',
                                  objectFit: 'cover'
                                }}
                                loading="lazy"
                              />
                            </div>
                          </Card>
                        </div>
                      </Col>
                    ))}
                  </Row>
                ) : (
                  <div className="empty-album-state text-center py-4 bg-light rounded-3">
                    <i className="bi bi-camera text-muted" style={{ fontSize: '2rem' }}></i>
                    <p className="text-muted mt-2 mb-0">No photos in this album yet</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </Container>
    </section>
  </div>
</div>

      {/* 🔥 Modal for Large Photo */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
        <Modal.Body className="text-center">
          {selectedPhoto && (
            <img
              src={selectedPhoto.photo_name}
              alt="Selected"
              style={{
                width: "100%",
                borderRadius: "10px",
              }}
            />
          )}
        </Modal.Body>

        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PhotoAlbum;
